import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';
import ym from 'react-yandex-metrika';

export const getAllProducts = createAsyncThunk(
  'kitchenMenu/getAllProducts',
  async (data, { rejectWithValue }) => {
    const api = '/menu/products?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          products: response.data.data.products,
          salesRaw: response.data.data.salesRaw
        };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const addMenu = createAsyncThunk(
  'kitchenMenu/addMenu',
  async (data, { rejectWithValue }) => {
    const api = '/menu/addMenu?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        ym('reachGoal','menu_publish');
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const toggleMenuStatus = createAsyncThunk(
  'kitchenMenu/toggleMenuStatus',
  async (data, { rejectWithValue }) => {
    const isEnabled = data.enabled
    const api = isEnabled ? '/menu/disableMenu?XDEBUG_SESSION_START=MyVSCode' : '/menu/enableMenu?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getModifierGroups = createAsyncThunk(
  'kitchenMenu/getModifierGroups',
  async (data, { rejectWithValue }) => {
    const api = '/products/modifiersGroups/getModifiersGroupsByKitchenId?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.modifiersGroups;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const createModifierGroups = createAsyncThunk(
  'kitchenMenu/createModifierGroups',
  async (data, { rejectWithValue }) => {
    const api = '/products/modifiersGroups/create?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateModifierGroups = createAsyncThunk(
  'kitchenMenu/updateModifierGroups',
  async (data, { rejectWithValue }) => {
    const api = '/products/modifiersGroups/update?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const deleteModifierGroups = createAsyncThunk(
  'kitchenMenu/deleteModifierGroups',
  async (data, { rejectWithValue }) => {
    const api = '/products/modifiersGroups/delete?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getModifierGroupsProducts = createAsyncThunk(
  'kitchenMenu/getModifierGroupsProducts',
  async (data, { rejectWithValue }) => {
    const api = '/products/modifiersGroupsProducts/getByModifierGroupId?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.modifiersGroups;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const createModifierGroupsProducts = createAsyncThunk(
  'kitchenMenu/createModifierGroupsProducts',
  async (data, { rejectWithValue }) => {
    const api = '/products/modifiersGroupsProducts/create?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {...data, modifierGroupProductId: response.data.data.modifierGroupProductId};
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateModifierGroupsProducts = createAsyncThunk(
  'kitchenMenu/updateModifierGroupsProducts',
  async (data, { rejectWithValue }) => {
    const api = '/products/modifiersGroupsProducts/update?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const deleteModifierGroupsProducts = createAsyncThunk(
  'kitchenMenu/deleteModifierGroupsProducts',
  async (data, { rejectWithValue }) => {
    const api = '/products/modifiersGroupsProducts/delete?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

const initialState = {
  //Menu
  allProductsGetRequestStatus: null,
  addMenuRequestStatus: null,
  toggleMenuRequestStatus: null,
  allProducts: [],
  salesRaw: [],
  currentRace: null,

  //Modifier Groups
  modifierGroupsGetRequestStatus: null,
  modifierGroups: [],
  currentModifierGroupId: null,
  modifierGroupsCreateRequestStatus: null,
  modifierGroupsUpdateRequestStatus: null,
  modifierGroupsDeleteRequestStatus: null,

  //Modifier Groups Products
  modifierGroupsProductsGetRequestStatus: null,
  modifierGroupsProducts: [],
  modifierGroupsProductCreateRequestStatus: null,
  modifierGroupsProductUpdateRequestStatus: null,
  modifierGroupsProductDeleteRequestStatus: null,
  loadingProductIds: [], // Массив ID продуктов, которые сейчас обновляются
};

const kitchenMenuSlice = createSlice({
  name: 'kitchenMenu',
  initialState,
  extraReducers: (builder) => {
    builder
      //Menu
      .addCase(getAllProducts.pending, (state) => {
        state.allProductsGetRequestStatus = 'pending';
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.allProductsGetRequestStatus = 'fulfilled';
        state.allProducts = action.payload.products;
        state.salesRaw = action.payload.salesRaw;
      })
      .addCase(getAllProducts.rejected, (state) => {
        state.allProductsGetRequestStatus = 'rejected';
      })
      .addCase(addMenu.pending, (state) => {
        state.addMenuRequestStatus = 'pending';
      })
      .addCase(addMenu.fulfilled, (state, action) => {
        state.addMenuRequestStatus = 'fulfilled';
        state.currentRace = {
          ...state.currentRace,
          menu: [{id: action.payload.menus.days[0].races[0].menuId}]
        };
      })
      .addCase(addMenu.rejected, (state) => {
        state.addMenuRequestStatus = 'rejected';
      })
      .addCase(toggleMenuStatus.pending, (state) => {
        state.toggleMenuRequestStatus = 'pending';
      })
      .addCase(toggleMenuStatus.fulfilled, (state) => {
        state.toggleMenuRequestStatus = 'fulfilled';
      })
      .addCase(toggleMenuStatus.rejected, (state) => {
        state.toggleMenuRequestStatus = 'rejected';
      })
      //Modifier Groups
      .addCase(getModifierGroups.pending, (state) => {
        state.modifierGroupsGetRequestStatus = 'pending';
      })
      .addCase(getModifierGroups.fulfilled, (state, action) => {
        state.modifierGroupsGetRequestStatus = 'fulfilled';
        state.modifierGroups = action.payload;
      })
      .addCase(getModifierGroups.rejected, (state) => {
        state.modifierGroupsGetRequestStatus = 'rejected';
      })
      .addCase(createModifierGroups.pending, (state) => {
        state.modifierGroupsCreateRequestStatus = 'pending';
      })
      .addCase(createModifierGroups.fulfilled, (state) => {
        state.modifierGroupsCreateRequestStatus = 'fulfilled';
      })
      .addCase(createModifierGroups.rejected, (state) => {
        state.modifierGroupsCreateRequestStatus = 'rejected';
      })
      .addCase(updateModifierGroups.pending, (state) => {
        state.modifierGroupsUpdateRequestStatus = 'pending';
      })
      .addCase(updateModifierGroups.fulfilled, (state) => {
        state.modifierGroupsUpdateRequestStatus = 'fulfilled';
      })
      .addCase(updateModifierGroups.rejected, (state) => {
        state.modifierGroupsUpdateRequestStatus = 'rejected';
      })
      .addCase(deleteModifierGroups.pending, (state) => {
        state.modifierGroupsDeleteRequestStatus = 'pending';
      })
      .addCase(deleteModifierGroups.fulfilled, (state) => {
        state.modifierGroupsDeleteRequestStatus = 'fulfilled';
      })
      .addCase(deleteModifierGroups.rejected, (state) => {
        state.modifierGroupsDeleteRequestStatus = 'rejected';
      })
      //Modifier Groups Products
      .addCase(getModifierGroupsProducts.pending, (state) => {
        state.modifierGroupsProductsGetRequestStatus = 'pending';
      })
      .addCase(getModifierGroupsProducts.fulfilled, (state, action) => {
        state.modifierGroupsProductsGetRequestStatus = 'fulfilled';
        state.modifierGroupsProducts = action.payload;
      })
      .addCase(getModifierGroupsProducts.rejected, (state) => {
        state.modifierGroupsProductsGetRequestStatus = 'rejected';
      })
      .addCase(createModifierGroupsProducts.pending, (state, action) => {
        state.modifierGroupsProductCreateRequestStatus = 'pending';
        // Добавляем productId в массив загружаемых
        const productId = action.meta.arg.productId;
        if (!state.loadingProductIds.includes(productId)) {
          state.loadingProductIds.push(productId);
        }
      })
      .addCase(createModifierGroupsProducts.fulfilled, (state, action) => {
        state.modifierGroupsProductCreateRequestStatus = 'fulfilled';
        
        // Обновляем продукт в массиве
        state.modifierGroupsProducts = state.modifierGroupsProducts.map((product) => {
          if (product.productId === action.payload.productId) {
            return { ...product, ...action.payload };
          }
          return product;
        });

        // Удаляем productId из массива загружаемых
        state.loadingProductIds = state.loadingProductIds.filter(
          id => id !== action.payload.productId
        );
      })
      .addCase(createModifierGroupsProducts.rejected, (state, action) => {
        state.modifierGroupsProductCreateRequestStatus = 'rejected';
        // Удаляем productId из массива загружаемых при ошибке
        const productId = action.meta.arg.productId;
        state.loadingProductIds = state.loadingProductIds.filter(
          id => id !== productId
        );
      })
      .addCase(updateModifierGroupsProducts.pending, (state, action) => {
        state.modifierGroupsProductUpdateRequestStatus = 'pending';
        // Добавляем productId в массив загружаемых
        const productId = action.meta.arg.productId;
        if (!state.loadingProductIds.includes(productId)) {
          state.loadingProductIds.push(productId);
        }
      })
      .addCase(updateModifierGroupsProducts.fulfilled, (state, action) => {
        state.modifierGroupsProductUpdateRequestStatus = 'fulfilled';
        
        // Обновляем продукт в массиве
        state.modifierGroupsProducts = state.modifierGroupsProducts.map((product) => {
          if (product.modifierGroupProductId === action.payload.modifierGroupProductId) {
            return { ...product, ...action.payload };
          }
          return product;
        });

        // Удаляем productId из массива загружаемых
        state.loadingProductIds = state.loadingProductIds.filter(
          id => id !== action.payload.productId
        );
      })
      .addCase(updateModifierGroupsProducts.rejected, (state, action) => {
        state.modifierGroupsProductUpdateRequestStatus = 'rejected';
        // Удаляем productId из массива загружаемых при ошибке
        const productId = action.meta.arg.productId;
        state.loadingProductIds = state.loadingProductIds.filter(
          id => id !== productId
        );
      })
      .addCase(deleteModifierGroupsProducts.pending, (state) => {
        state.modifierGroupsProductDeleteRequestStatus = 'pending';
      })
      .addCase(deleteModifierGroupsProducts.fulfilled, (state) => {
        state.modifierGroupsProductDeleteRequestStatus = 'fulfilled';
      })
      .addCase(deleteModifierGroupsProducts.rejected, (state) => {
        state.modifierGroupsProductDeleteRequestStatus = 'rejected';
      })
      .addCase(PURGE, () => {
        return initialState;
      });
  },
  reducers: {
    //Menu
    updateAllProducts: (state, action) => { state.allProducts = action.payload; },
    updateProducts: (state, action) => {
      const updatedProducts = action.payload;
      state.allProducts = state.allProducts.map((product) => {
          const updatedProduct = updatedProducts.find(
              (updated) => updated.productId === product.productId
          );

          return updatedProduct ? { ...product, ...updatedProduct } : product;
      });
    },
    setCurrentRace: (state, action) => { state.currentRace = action.payload; },
    updateCurrentRace(state, action) {
      state.currentRace = {
        ...state.currentRace,
        ...action.payload
      };
    },
    setCurrentModifierGroupId: (state, action) => {
      state.currentModifierGroupId = action.payload;
    },
  },
});

export const {
  updateAllProducts,
  updateProducts,
  setCurrentRace,
  updateCurrentRace,
  setCurrentModifierGroupId,
} = kitchenMenuSlice.actions;

export default kitchenMenuSlice.reducer;
